import routeName from '../constant';

const routes = [
    {
        path: 'annuity-change',
        name: routeName.ANNUITY_CHANGE,
        component: () => import('@/views/aplCatl640and631/AC/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '年金給付方式變更', leaveAlert: true, code: 'AC', unableBack: true },
    }];

export default routes;
